import React, { Component } from 'react'
import Web3 from 'web3'
import './cssShopToken.css';
import utils from '../../library'
import Icons from '../Icons/Icons'
import { create, all } from 'mathjs'

const multiplier=1000

const config= {
    number: 'BigNumber',                   
    precision: 64           
  }
  
  const math = create(all, config)

class ShopToken extends Component {
constructor(props){
    super()
    this.state={favorite:false,balance:0,refilling:false,
        isItem:false,
        icon:"https://dapp.dfohub.com/assets/img/default-logo.png",
    description:"",
    collectionicon:"https://dapp.dfohub.com/assets/img/default-logo.png",
collection:"0xfa28ED428D54424D42ED4F71415315df2f2E49D6",
collectionname:""}
}



async buy(){
    let addr=this.props.address
    let index=this.props.index
    let ticket=this.props.ticket
    let max=await utils.ETHBalance()
    document.getElementById('cost_'+this.props.index).style.color="white"
    let spend=await web3.utils.toWei(""+math.evaluate(math.bignumber(document.getElementById("cost_"+index).value)*math.bignumber(multiplier)), 'finney')
    alert(spend)
    alert(max)
    
    if(spend>=web3.utils.toWei(max)){
        alert("If you spend all your ETH you won't have enough to pay for tyhe gas!")
    }else{
        await window.ethereum.enable().then(async function (accounts) { 
            const { REACT_APP_TICKETABI } = process.env;
            const { REACT_APP_TICKET } = process.env;
            const door = new web3.eth.Contract(JSON.parse(REACT_APP_TICKETABI), ticket) 
            await door.methods.buy(addr,"0x54d5aC00babbF6884336D313d7Afe08279015DD4").send({from: accounts[0] , gasLimit: 223456 , value: ""+spend})
        })  
        this.loadToken()
    }
}

async setPrice(){
    let addr=this.props.address
    let index=this.props.index
    let priceList=this.props.priceList
    let price=math.evaluate(math.bignumber(document.getElementById("ShopToken_item_setprice_field_"+index).value)*math.bignumber(multiplier))
  
    if((price>>1)||(price==1)){
        await window.ethereum.enable().then(async function (accounts) { 
            const { REACT_APP_PriceListABI } = process.env;
            const prices = new web3.eth.Contract(JSON.parse(REACT_APP_PriceListABI), priceList) 
            await prices.methods.setPrice(addr,""+price).send({from: accounts[0] , gasLimit: 123456 })
            document.getElementById('Shop_item_price_'+index).innerHTML=document.getElementById("ShopToken_item_setprice_field_"+index).value
        }) 
        this.loadToken() 
    }else{
        alert("PRICE MUST BE >= "+(math.evaluate(1/multiplier)))
    }
}

async calculate_price(){
    let amount=math.bignumber(document.getElementById('Shop_item_setamount_field_'+this.props.index).value)
    if(amount>this.state.balance){
        document.getElementById('Shop_item_setamount_field_'+this.props.index).value=this.state.balance
        amount=math.bignumber(this.state.balance)
    }
    //let price=parseFloat(1000000*amount)*(parseFloat(this.props.price)/1000)/1000000
    let a=math.bignumber((1000000*amount)*(this.props.price/multiplier))
 
    let b=math.bignumber(1000000)
 

    let price=math.divide(a,b)
    document.getElementById("cost_"+this.props.index).style="text-align:right;"
    document.getElementById('cost_'+this.props.index).value=price
    let max=await utils.ETHBalance()
    document.getElementById('cost_'+this.props.index).style.color="white"
    document.getElementById("Shop_item_button_"+this.props.index).style.color="white"
    if((price>>math.bignumber(max))||(price==0)){
       
        document.getElementById('cost_'+this.props.index).style.color="red"
        document.getElementById("Shop_item_button_"+this.props.index).style.color="red"
    }
}

calculate_backprice(){
    let cost=document.getElementById('cost_'+this.props.index).value
    //let amount=parseFloat(1000000*cost)/(parseFloat(this.props.price)/1000)/1000000
    let a=math.bignumber(1000000*cost)
    let b=math.evaluate(math.bignumber(this.props.price)/multiplier)
    let amount=math.evaluate(a/b/1000000)
    document.getElementById('Shop_item_setamount_field_'+this.props.index).value=amount
    document.getElementById('Shop_item_setamount_field_'+this.props.index).style.color="white"
    document.getElementById("Shop_item_button_"+this.props.index).style.color="white"
    if(this.state.balance<<amount){
        document.getElementById('Shop_item_setamount_field_'+this.props.index).style.color="red"
        document.getElementById("Shop_item_button_"+this.props.index).style.color="red"
    }
}

setMax(){
    document.getElementById('Shop_item_setamount_field_'+this.props.index).style.color="white"
    document.getElementById('Shop_item_setamount_field_'+this.props.index).value=this.state.balance
    this.calculate_price()
}

async setMin(){
    let decimals = await utils.decimals(this.props.address)
    document.getElementById('Shop_item_setamount_field_'+this.props.index).style.color="white"
    document.getElementById('Shop_item_setamount_field_'+this.props.index).value=math.divide(math.bignumber(1.0),math.bignumber(Math.pow(10,decimals)))
    this.calculate_price()
}

async setETHMax(){
    let max=await utils.ETHBalance()
    document.getElementById('cost_'+this.props.index).style.color="white"
    document.getElementById('cost_'+this.props.index).value=max
    this.calculate_backprice()
}

async refillMode(){
    if(!this.state.refilling){
    this.setState({refilling:true})
    this.setMaxSendToBox()
    }else{
    this.setState({refilling:false})
    }
}

check_price(){
    document.getElementById("ShopToken_item_setprice_button_"+this.props.index).style.color="white"
    if(this.state.refilling){
        if(document.getElementById("ShopToken_item_setprice_field_"+this.props.index).value>>document.getElementById("ShopToken_item_setprice_field_"+this.props.index).getAttribute("max_balance"))  
        document.getElementById("ShopToken_item_setprice_button_"+this.props.index).style.color="red"
        document.getElementById("ShopToken_item_setprice_field_"+this.props.index).style.color="red"
    }
    if(document.getElementById("ShopToken_item_setprice_field_"+this.props.index).value==="")
    document.getElementById("ShopToken_item_setprice_button_"+this.props.index).style.color="red"
    if(math.bignumber(parseFloat(document.getElementById("ShopToken_item_setprice_field_"+this.props.index).value))<math.evaluate(1/multiplier)){
        document.getElementById("ShopToken_item_setprice_button_"+this.props.index).style.color="red"
        if(parseFloat(document.getElementById("ShopToken_item_setprice_field_"+this.props.index).value)>0){
            document.getElementById("ShopToken_item_setprice_field_"+this.props.index).value=""+math.evaluate(1/multiplier)
            document.getElementById("ShopToken_item_setprice_button_"+this.props.index).style.color="white"
        }
    }
}

async setMaxSendToBox(){
    let addr=this.props.address
    let index=this.props.index
    
    await window.ethereum.enable().then(async function (accounts) { 
        let bal=await utils.balanceOf(accounts[0],addr)
        document.getElementById("ShopToken_item_setprice_field_"+index).setAttribute("max_balance",bal )   
        document.getElementById("ShopToken_item_setprice_field_"+index).value=bal
        document.getElementById("ShopToken_item_setprice_field_"+index).style.color="white"
        document.getElementById("ShopToken_item_setprice_button_"+index).style.color="white"
        if(bal==0){
            document.getElementById("ShopToken_item_setprice_field_"+index).style.color="red"
            document.getElementById("ShopToken_item_setprice_button_"+index).style.color="red"
        }
    })
}

async sendToBox(){
    let addr=this.props.address
    let index=this.props.index
    let box=this.props.db
    if(document.getElementById("ShopToken_item_setprice_field_"+index).value>0){
        await window.ethereum.enable().then(async function (accounts) { 
            const { REACT_APP_ABI } = process.env;
            const tkn = new web3.eth.Contract(JSON.parse(REACT_APP_ABI), addr) 
            await tkn.methods.transfer(box,web3.utils.toWei(""+document.getElementById("ShopToken_item_setprice_field_"+index).value)).send({from: accounts[0] , gasLimit: 149174 })
           }) 
        this.setMaxSendToBox()
    }else{
        alert("SEND MORE THAN 0")
    }
}

getIcon(icon,dim){
    return <Icons icon={icon} d={dim}/>
}

async loadToken(){
    let addr=this.props.address
    let index=this.props.index
    let ticket=this.props.ticket
    let db=this.props.db
    let bal
    let _collection
    let collectionJSON
    if(!this.props.ghost){
    await utils.checkFavorite(addr,index)
    await utils.checkGhost(addr,index)
    }else{
    await utils.checkGhostFavorite(addr,index)
    }
    let metaJSON
    await window.ethereum.enable().then(async function (accounts) { 
        try{ 
            let name = await utils.nameOf(addr)
            let symbol = await utils.symbolOf(addr)
            let box = await utils.ticket2Box(ticket)  
            bal = await utils.balanceOf(box,addr)
            let decimals = await utils.decimals(addr)
            document.getElementById("Shop_item_"+index).textContent=name   
            document.getElementById("Shop_item_setamount_field_"+index).value=bal
            document.getElementById("Shop_item_setamount_field_"+index).setAttribute("box_balance",bal )   
            document.getElementById("cost_"+index).style="text-align:left;"
            document.getElementById("cost_"+index).value=symbol
        }catch(e){console.log("SHOP TOKEN ERROR "+db+e)}

        try{
            
            _collection=await utils.item2collection(addr)

            let meta=await utils.itemMeta(addr)
            alert(meta)
            let collectionmeta=await utils.checkITEM(_collection)
            metaJSON=await utils.itemMetaJSON(meta)
            collectionJSON=await utils.itemMetaJSON(collectionmeta)
            alert(metaJSON)
           // document.getElementById("ShopToken_item_icon"+this.props.index).src=ima
        }catch(e){
            console.log("SHOP TOKEN ERROR ITEM META"+e)
        }
    })
    if(metaJSON)this.setState({isItem:true,collection:_collection,collectionicon:collectionJSON["image"],collectionname:collectionJSON["name"],icon:"http://ipfs.io/"+metaJSON["image"].substring(7)})
    if(metaJSON)this.setState({description:metaJSON["description"]})
this.setState({balance:bal})
this.render()
}

    componentDidMount(){
        this.loadToken()
    }

    setCookie(){
        utils.setCookie("favorite",this.props.address,this.props.index)
        this.loadToken()
    }

    render(props){
    console.log("SHOP TOKEN PROPS>",this.props)
        return ( <>
    <div className={(this.state.isItem)?"ShopToken_item_row_container":"ShopToken_row_container"}>
        <div className="ShopToken_product_tool">
            <div id={"favorite_"+this.props.index} className={(this.state.favorite)?"favorite":"notfavorite"} onClick={() => this.setCookie()}><Icons icon="star" d="50"/></div>
            <div id={"favorite_"+this.props.index} className={(this.state.favorite)?"favorite2 dhover darkhover":"notfavorite2 dhover darkhover"} onClick={() => openProduct(this.props.ticket,this.props.index)}><Icons icon="pill" d="50"/></div>
        </div>
        <div className="ShopToken_row">        
            <div id={"Shop_Token_item_panel_"+this.props.index} className={(this.state.balance==0)?"Shop_Token_item_panel_disabled dark darkblue":"Shop_Token_item_panel dark darkblue"}>
                {(this.props.edit)?<div className={(this.state.refilling)?"ShopToken_refill_true light lightblue":"ShopToken_refill_false"} onClick={() => this.refillMode()}><Icons icon="drops" d="50"></Icons></div>:""}
                <div className="ShopToken_item_icon_container">
               <img id={"ShopToken_item_icon"+this.props.index} className="ShopToken_item_icon" onClick={() => window.open('https://ropsten.etherscan.io/address/'+this.props.address)} src={this.state.icon}></img>
               <div className="feed_link light lighthover" onClick={() => window.open("?feed="+this.props.address)}><Icons icon="feed" d="50"></Icons></div>
               </div>
               <div id={"Shop_item_"+this.props.index} className="ShopToken_item_label text white">loading...</div>
               <img className="ShopToken_item_price_icon" src="https://i.imgur.com/FPL7c5a.png"></img>
               <span id={"Shop_item_price_"+this.props.index} className="ShopToken_item_price text white right">{(this.props.price)/multiplier}</span>
               <div className="clear"></div>
               {(this.state.isItem)?
               <div id="Shop_token_itemPanel" className="Shop_token_itemPanel light lightblue">
               <div className="Shop_Token_itemimage_container"><img className="ShopToken_item_image" src={utils.clean(this.state.icon)}></img></div>
                    <div id={"Shop_token_descPanel_"+this.props.index} className="Shop_token_descPanel text white dark darkblue">{utils.clean(this.state.description)}</div>
                    <div id={"Shop_token_item_controlPanel_"+this.props.index} className="Shop_token_item_controlPanel text white">
                      <div className="ShopToken_item_openitems_button dark darkblue text white" onClick={() => window.open("https://ethitem.com/?interoperable="+this.props.address)}><Icons icon="ethitem" d="30"/></div>
                      <div className="ShopToken_item_openitems_button dark darkblue text white" onClick={() => window.open("https://ropsten.etherscan.io/token/"+this.props.address)}><Icons icon="etherscan" d="30"/></div>
                      <div className="ShopToken_item_collection text white right"><div className="ShopToken_collection_icon right"><img src={this.state.collectionicon} className="Shop_token_collectionicon"/></div><div className="ShopToken_collection_label right" onClick={() => window.open("https://ethitem.com/?collection="+utils.clean(this.state.collection))}>{utils.clean(this.state.collectionname)}</div></div>
                            
                    </div>
               </div>
               :<></>
    }
                {(this.props.edit)?
                <div className="ShopToken_item_setprice light lightblue text white">
                    <input id={"ShopToken_item_setprice_field_"+this.props.index} className="ShopToken_item_setprice_field light lightblue text white" type="text" onKeyUp={() => this.check_price()} onKeyPress={() => this.check_price()}></input>
                    {(!this.state.refilling)
                    ?<div id={"ShopToken_item_setprice_button_"+this.props.index} className="ShopToken_item_setprice_button dark darkblue text white" onClick={() => this.setPrice()}><Icons icon="pen" d="40"/> <div className="button_label_right">Set Price</div></div>
                    :<div id={"ShopToken_item_setprice_button_"+this.props.index} className="ShopToken_item_setprice_button dark darkblue text white"  onClick={() => this.sendToBox()}><div className="button_label_left">Send to </div><Icons icon="box" d="40"/></div>
                    }
                </div>
                :
               <div className="ShopToken_item_setprice light lightblue text white">
                   <div className="ShopToken_buydrop dhover darkhover" onClick={() => this.setMin()}><Icons icon="drop" d="50"/> </div>
                   <input id={"Shop_item_setamount_field_"+this.props.index} className="ShopToken_item_setamount_field light lightblue text white" type="text" onKeyUp={() => this.calculate_price()} onKeyPress={() => this.calculate_price()}></input>
                   <div className="ShopToken_item_icon_container">
                   <img id={"ShopToken_item_icon2"+this.props.index} className="ShopToken_item_icon"  onClick={() => this.setMax()}  src={this.state.icon}></img>
                   <div  className="feed_link light lighthover" onClick={() => window.open("?feed="+this.props.address)}><Icons icon="feed" d="50"></Icons></div>
                   </div>
                   <input  id={"cost_"+this.props.index} className="ShopToken_item_setamount_field light lightblue text white" type="text"  onKeyUp={() => this.calculate_backprice()} onKeyPress={() => this.calculate_backprice()}></input>
                   <img className="ShopToken_item_icon"  onClick={() => this.setETHMax()} src="https://i.imgur.com/FPL7c5a.png"></img>
                   <div id={"Shop_item_button_"+this.props.index} className="ShopToken_item_setprice_button dark darkblue text white" onClick={() => this.buy()}><Icons icon="chart" d="40"/><div className="button_label_right">buy!</div></div>
               </div>
                }          
            </div>
        </div>
    </div>   
    </>
        );
    }


}

function openProduct(ticket,index){ 
window.open("/smartshop/?shop="+ticket+"&index="+index.substr(index.lastIndexOf("x")+1,10))
}
 
const web3 = new Web3(Web3.givenProvider || "http://localhost:8545")

export default ShopToken